import request from '@/utils/request';

export function getApps (filter) {
  return request.get('api/admin/apps', filter);
}

export function saveApp (app) {
  return request.post('/api/admin/apps', app);
}

export function updateApp (app) {
  return request.put('/api/admin/apps/', app);
}

export function deleteApp (id) {
  return request.delete('/api/admin/apps/', id);
}

export function getAppConfig (id) {
  return request.get('/api/admin/apps/config', id);
}



// WEBPACK FOOTER //
// ./src/api/apps.js